import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import {
  BlockedListSortDirection,
  BlockedListSortProperty,
  defaultBlockedCreativesFilter,
  type BlockedCreativesFilter,
} from './model';

export interface BlockedListRouteSearch {
  search?: string;
  page?: number;
  size?: number;
  sortProperty?: BlockedListSortProperty | null;
  sortDirection?: BlockedListSortDirection;
}

export function blockedListRouteSearchSchema(
  search: Record<string, unknown>,
): BlockedListRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const page = optionalPositiveInteger(search['page']);
  const size = optionalPositiveInteger(search['size']);
  const sortProperty = ownedValue(BlockedListSortProperty, search['sortProperty']);
  const sortDirection = ownedValue(BlockedListSortDirection, search['sortDirection']);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
    ...(sortProperty ? { sortProperty } : {}),
    ...(search['sortProperty'] === null ? { sortProperty: null } : {}),
    ...(sortDirection ? { sortDirection } : {}),
  };
}

export function parseBlockedListRouteSearch(
  search: BlockedListRouteSearch,
): BlockedCreativesFilter {
  return {
    searchTerm: search.search ?? defaultBlockedCreativesFilter.searchTerm,
    page: search.page ? search.page - 1 : defaultBlockedCreativesFilter.page,
    size: search.size ?? defaultBlockedCreativesFilter.size,
    sortProperty:
      search.sortProperty === null
        ? null
        : (search.sortProperty ?? defaultBlockedCreativesFilter.sortProperty),
    sortDirection: search.sortDirection ?? defaultBlockedCreativesFilter.sortDirection,
  };
}

export function serializeBlockedListRouteSearch(
  filter: BlockedCreativesFilter,
): BlockedListRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultBlockedCreativesFilter.size ? { size: filter.size } : {}),
    ...(filter.sortProperty !== defaultBlockedCreativesFilter.sortProperty
      ? { sortProperty: filter.sortProperty }
      : {}),
    ...(filter.sortDirection !== defaultBlockedCreativesFilter.sortDirection
      ? { sortDirection: filter.sortDirection }
      : {}),
  };
}

function ownedValue<TValue extends string>(
  values: Record<string, TValue>,
  value: unknown,
): TValue | undefined {
  return typeof value === 'string' && Object.values(values).includes(value as TValue)
    ? (value as TValue)
    : undefined;
}
